module.exports = __webpack_public_path__ + "static/slide-2-5aad94a0666286e6df323791bdc2584d.jpg";